import { ApiResponse } from '../for-api';

export interface HasFieldLength {
  fieldLength: number;
}

export interface HasLength {
  length: number;
}

export interface InputLayoutField extends HasFieldLength {
  name?: string;
  headerName?: string;
  notes?: string;
}

export interface InputLayoutFields {
  fields: InputLayoutField[];
}

export enum FieldDelimiter {
  COMMA = 'COMMA',
  PIPE = 'PIPE',
  TAB = 'TAB',
  FIXED = 'FIXED',
}

export interface OutputLayoutField extends HasFieldLength {
  name?: string;
  source?: string; // 'Client' | 'Experian' | 'User';
  headerName?: string;
  notes?: string;
  constantValue?: string;
  outputOrder: number;
  category: string;
  exclusiveSubCodes?: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  meta?: Record<string, any>;
  outputFile?: string;
}

export interface OutputLayoutFieldWithDetails extends OutputLayoutField {
  defaultValues?: string;
  validValues?: string;
  description?: string;
  displayGroupCode?: string;
}

export type OutputLayoutFieldsWithDetailsApiResponse = ApiResponse<
  OutputLayoutFieldWithDetails[]
>;

export type HasFieldDimensions<T> = T & {
  begin: number;
  end: number;
};

export type HasRowColor<T> = T & {
  rowColor?: string;
};

export interface InputLabel {
  name: string;
  description?: string;
  fieldLength?: number;
}
export interface AttributesFromFullAttribute {
  code: string;
  attributeCodes: string[];
}

export interface OutputLayoutFieldLookups {
  fields: OutputLayoutField[];
  delimiter: FieldDelimiter;
  isCustomized?: boolean;
}
export type InputLabelsMap = Record<string, InputLabel>;
export type InputLabelsMapApiResponse = ApiResponse<InputLabelsMap>;
export type OutputLayoutFieldsResponse = ApiResponse<OutputLayoutField[]>;
